class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    if (window.location.pathname === "/cart") return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("tw-overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("tw-overflow-hidden");
  }

  async renderContents(parsedState) {
    this.productId = parsedState?.id;

    await this.renderSections(parsedState?.sections);

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay")?.addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  async refresh() {
    await this.renderSections();
    this.querySelector("#CartDrawer-Overlay")?.addEventListener("click", this.close.bind(this));
  }

  async renderSections(sections) {
    // Some apps (e.g. Easify) return a cart response without `sections` -> fetch them
    if (!sections || !sections["cart-drawer"]) {
      sections = await this.fetchSections();
    }
    if (!sections) return false;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const html = sections[section.id];

      if (!sectionElement || !html) return;

      const innerHTML = this.getSectionInnerHTML(html, section.selector);
      if (innerHTML !== null) sectionElement.innerHTML = innerHTML;
    });

    this.updateEmptyState();
    return true;
  }

  async fetchSections() {
    const ids = this.getSectionsToRender()
      .map((section) => section.id)
      .join(",");
    const cartUrl = (window.routes && window.routes.cart_url) || "/cart";

    try {
      const response = await fetch(`${cartUrl}?sections=${ids}`);
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.error("Cart drawer: could not fetch sections", error);
      return null;
    }
  }

  updateEmptyState() {
    const isEmpty = !!this.querySelector(".drawer__inner-empty");
    this.classList.toggle("is-empty", isEmpty);
    this.querySelector(".drawer__inner")?.classList.toggle("is-empty", isEmpty);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return null;
    const element = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return element ? element.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
